import { useCreditCardEnabledSubscription } from 'common/hooks/useCreditEnabledSubscription';

import type { PaymentCardListObservableQuery } from '../usePaymentCardsList';
import { PaymentCardListTable_ItemFragmentDoc } from '../usePaymentCardsList/paymentCardsList.gql';

type UsePaymentCardEnabedSubscriptionParams = {
  onData: (creditCardId: string) => void;
  skip?: boolean;
  observable: PaymentCardListObservableQuery;
  creditCardId: string;
};

export const usePaymentCardEnabledSubscription = ({
  creditCardId,
  observable,
  onData,
  skip,
}: UsePaymentCardEnabedSubscriptionParams) => {
  useCreditCardEnabledSubscription({
    onData({ client, data: { data: event } }) {
      if (!event) {
        return;
      }
      client.cache.writeFragment({
        data: event.creditCardEnabled,
        fragment: PaymentCardListTable_ItemFragmentDoc,
      });
      observable.updateQuery((existingQueryData) => {
        const newcacheData = {
          ...existingQueryData,
          viewer: {
            ...existingQueryData.viewer,
            company: {
              ...existingQueryData.viewer.company,
              paymentCards: {
                ...existingQueryData.viewer.company.paymentCards,
                edges: existingQueryData.viewer.company.paymentCards.edges.map(
                  (cardEdge) => ({
                    ...cardEdge,
                    node:
                      cardEdge.node.creditCardId ===
                      event.creditCardEnabled.creditCardId
                        ? event.creditCardEnabled
                        : cardEdge.node,
                  }),
                ),
              },
            },
          },
        };
        return newcacheData;
      });
      onData?.(event.creditCardEnabled.creditCardId);
    },
    skip: skip ?? true,
    variables: {
      creditCardId: creditCardId,
    },
  });
};
